import React from "react";

export default function TableHeader() {
  return (
    <thead>
      <tr>
        <th scope="col" className="subhead-3">Game</th>
        <th scope="col" className="subhead-3">Buy-In</th>
        <th scope="col" className="text-center subhead-3">Waiting</th>
      </tr>
    </thead>
  );
}
